module.exports = __webpack_public_path__ + "img/home.e8391c75.svg";